import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useApi } from '@/composables/useApi'

interface UserInfo {
  id: string
  email: string
  username: string
  avatar?: string
  baseTimezone?: string
  language?: string
}

export const useUserStore = defineStore('user', () => {
  const { get } = useApi()

  const token = ref<string | null>(localStorage.getItem('nm_token'))
  const refreshTokenVal = ref<string | null>(localStorage.getItem('nm_refresh_token'))
  const userInfo = ref<UserInfo | null>(null)

  const isLoggedIn = computed(() => !!token.value)

  const setToken = (newToken: string | null) => {
    token.value = newToken
    if (newToken) {
      localStorage.setItem('nm_token', newToken)
    } else {
      localStorage.removeItem('nm_token')
    }
  }

  const setRefreshToken = (newRefreshToken: string | null) => {
    refreshTokenVal.value = newRefreshToken
    if (newRefreshToken) {
      localStorage.setItem('nm_refresh_token', newRefreshToken)
    } else {
      localStorage.removeItem('nm_refresh_token')
    }
  }

  const setUser = (user: UserInfo | null) => {
    userInfo.value = user
  }

  const fetchUser = async () => {
    if (!token.value) return
    try {
      const data = await get<UserInfo>('/auth/me')
      userInfo.value = data.data || data as any
    } catch {
      userInfo.value = null
    }
  }

  const logout = () => {
    setToken(null)
    setRefreshToken(null)
    userInfo.value = null
  }

  if (token.value && !userInfo.value) {
    fetchUser()
  }

  return { token, userInfo, isLoggedIn, setToken, setRefreshToken, setUser, fetchUser, logout }
})
